// frontend/src/features/seo/components/SeoKpiStrip.js
import React from 'react';

export default function SeoKpiStrip({ kpis, onKpiClick }) {
  if (!kpis) return null;

  return (
    <section className="seo-kpi-strip" aria-label="SEO Performance KPIs">
      <div
        className="seo-kpi-card clickable"
        onClick={() => onKpiClick && onKpiClick('visibility')}
        title="View organic search performance"
      >
        <div className="seo-kpi-header">
          <span className="seo-kpi-label">Organic Search Impressions</span>
          <span className="seo-kpi-icon blue">
            <i className="fas fa-eye"></i>
          </span>
        </div>
        <div className="seo-kpi-value-row">
          <span className="seo-kpi-value">{kpis.organicImpressions}</span>
          <span className="seo-kpi-trend positive">{kpis.impressionsTrend}</span>
        </div>
        <span className="seo-kpi-subtext">Last 30 days across Google & Bing</span>
      </div>

      <div
        className="seo-kpi-card clickable"
        onClick={() => onKpiClick && onKpiClick('visibility')}
        title="View generative AI citations"
      >
        <div className="seo-kpi-header">
          <span className="seo-kpi-label">AI Answer Engine Citations</span>
          <span className="seo-kpi-icon purple">
            <i className="fas fa-sparkles"></i>
          </span>
        </div>
        <div className="seo-kpi-value-row">
          <span className="seo-kpi-value">{kpis.aiCitations}</span>
          <span className="seo-kpi-trend positive">{kpis.aiCitationsTrend}</span>
        </div>
        <span className="seo-kpi-subtext">Perplexity, ChatGPT & Google AI Overviews</span>
      </div>

      <div
        className="seo-kpi-card clickable"
        onClick={() => onKpiClick && onKpiClick('topics')}
        title="Explore detected competitor content gaps"
      >
        <div className="seo-kpi-header">
          <span className="seo-kpi-label">Topic Gaps Identified</span>
          <span className="seo-kpi-icon amber">
            <i className="fas fa-compass"></i>
          </span>
        </div>
        <div className="seo-kpi-value-row">
          <span className="seo-kpi-value">{kpis.topicGapsIdentified}</span>
          <span className="seo-kpi-pill">High Opportunity</span>
        </div>
        <span className="seo-kpi-subtext">Queries where competitors lack depth</span>
      </div>

      <div
        className="seo-kpi-card clickable"
        onClick={() => onKpiClick && onKpiClick('briefs')}
        title="View active content briefs in progress"
      >
        <div className="seo-kpi-header">
          <span className="seo-kpi-label">Active Content Briefs</span>
          <span className="seo-kpi-icon green">
            <i className="fas fa-file-signature"></i>
          </span>
        </div>
        <div className="seo-kpi-value-row">
          <span className="seo-kpi-value">{kpis.activeBriefs}</span>
          <span className="seo-kpi-pill success">Grounded</span>
        </div>
        <span className="seo-kpi-subtext">Linked to M06 Content Studio</span>
      </div>

      <div
        className="seo-kpi-card clickable alert-card"
        onClick={() => onKpiClick && onKpiClick('refresh')}
        title="View decaying content requiring refresh"
      >
        <div className="seo-kpi-header">
          <span className="seo-kpi-label">Pages Requiring Refresh</span>
          <span className="seo-kpi-icon red">
            <i className="fas fa-triangle-exclamation"></i>
          </span>
        </div>
        <div className="seo-kpi-value-row">
          <span className="seo-kpi-value alert-text">{kpis.pagesRequiringRefresh}</span>
          <span className="seo-kpi-pill danger">Stale Claims</span>
        </div>
        <span className="seo-kpi-subtext">Outdated claims or traffic drops &gt;20%</span>
      </div>
    </section>
  );
}
